export default "__VITE_ASSET__BKTgV9wH__"